import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Router,ActivatedRoute } from '@angular/router';
import { CommonService } from './../../services/common.service';
import { UserService } from './../../services/user.service';
import { EncrDecrService } from '../../services/encr-decr.service';
declare var $: any;

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})
export class AddUserComponent implements OnInit {

  user_id:any=0;
  company_id:any=0;
  APIKEY:any=0;
  notification:number;
  editUserForm: FormGroup;
  submitted = false;
  role_list:any='';
  edit_userid:number=0;
  imagePath:any='assets/images/users/profile_pic.png';
  dropdownList = [];
  dropdownSettings = {};
  selectedItems:any = {};
  customer_per:any='';
  customer_list:any={};
  customer_list_event:boolean=false;
  btnDisable: boolean = false;
  model={};

  constructor(private formBuilder: FormBuilder,
    private _User:UserService,
    private _Common:CommonService,
    private toastr: ToastrService,
    private _router : Router,
    private _activatedroute: ActivatedRoute,
    private EncrDecr: EncrDecrService,) { }

  ngOnInit() {
    this.user_id =localStorage.getItem('id');
    this.company_id =localStorage.getItem('company_id');
    this.APIKEY =localStorage.getItem('APIKEY');  
   
    this.setFormValue();
    this._activatedroute.params.subscribe(params => {
      this.edit_userid = params['id'];
    });
    const data= {
      APIKEY : this.APIKEY,
      company_id : this.company_id,
    }

    this.editUserForm.controls['country_code'].setValue('+1', {onlySelf: true});
    this.editUserForm.controls['status'].setValue('active', {onlySelf: true});
    this.getRoleList(data);
    this.getCustomerLis(data,'normal');
    this.getCustomerListDrop();

  }

 getCustomerLis(data,mode){
  this._Common.getCustomerList(data)
  .subscribe(
    res => { 
        if(mode=='custper'){
          this.selectedItems=res.data;
        }
        this.dropdownList=res.data;
      },
  );}

  getCustomerListDrop(){
    this.dropdownSettings = {
      singleSelection: false,
      enableCheckAll:false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
    };
   }
  
  onItemSelect(item: any) {
      // console.log(this.selectedItems);
  }
  onSelectAll(items: any) {
      // console.log(items);
  }
  

 public onCustomerPer(value:boolean){  
    if(value!=true){
      this.selectedItems = [];
      this.customer_per='';
    }
    else{
      const data= {
        APIKEY : this.APIKEY,
        company_id : this.company_id,
      } 
      const mode='custper';
      this.getCustomerLis(data,mode);
      this.customer_per='all';
    }     
  }
  
  getRoleList(data){
    this._Common.getRoleList(data)
      .subscribe(
        res => { 
         this.role_list=res.data;
        },
      );
  }
  
  setFormValue(){
    this.editUserForm = this.formBuilder.group({
        first_name: ['', Validators.required],
        last_name: [''],
        email: ['', [Validators.required, Validators.email]],
        password: ['', [Validators.required, Validators.minLength(6)]],
        country_code: [''],
        phone: [''],
        alter_phone: [''],
        notification: [''],
        role: ['',Validators.required],
        note: [''],
        status: [''],
        profile_pic: [''],
        id: ['0'],
    });
  }


  onSelectFile(event) {
    if (event.target.files && event.target.files[0]) {
      var reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event:any) => {
        this.imagePath = event.target.result;
      }
      const file = event.target.files[0];
      this.editUserForm.get('profile_pic').setValue(file);
     }
  } 

  

  // convenience getter for easy access to form fields
  get f() { return this.editUserForm.controls; }

  onSubmit() {
    this.btnDisable = true;
      this.submitted = true;

      // stop here if form is invalid
      if (this.editUserForm.invalid) {
            return;
      }

    //alert('SUCCESS!! :-)')
    const formData = new FormData();
    formData.append('first_name', this.editUserForm.get('first_name').value);
    formData.append('last_name', this.editUserForm.get('last_name').value);
    formData.append('email', this.editUserForm.get('email').value);
    formData.append('password', this.EncrDecr.set(localStorage.getItem('key'), this.editUserForm.get('password').value));
    //formData.append('password', this.editUserForm.get('password').value);
    formData.append('country_code', this.editUserForm.get('country_code').value);
    formData.append('phone', this.editUserForm.get('phone').value);
    formData.append('alter_phone', this.editUserForm.get('alter_phone').value);
    formData.append('note', this.editUserForm.get('note').value);
    formData.append('role', this.editUserForm.get('role').value);
    formData.append('status', this.editUserForm.get('status').value);
    formData.append('profile_pic', this.editUserForm.get('profile_pic').value);
    formData.append('customer_per', this.customer_per);
    formData.append('customer_list', JSON.stringify(this.selectedItems));
    //formData.append('notification', this.editUserForm.get('notification').value);
   
    formData.append('user_id', this.user_id);
    formData.append('company_id', this.company_id);
    formData.append('APIKEY', this.APIKEY);
 
    this._User.addUser(formData).subscribe(
      res => {
          //console.log(res); return false;
        if(res.status==true){ 
           this.toastr.success(res.message, 'Success');
           //this. ngOnInit();
            this._router.navigateByUrl('/redirect').then(() => {
            this._router.navigateByUrl('/user/user-list/all');
           });
         }
        else{
           this.toastr.error(res.message, 'Error');
        }
      }  
   );
 }

  public onChange(event): void {  // event will give you full breif of action
    const newVal = event.target.value;
    var splitted = newVal.split("-", 3); 
    var name= splitted[1];
    if(name==='Mobile User'){
        this.customer_list_event=true;
    }
    else{
        this.customer_list_event=false;
    }
  }

  public notify(value) {
    
    this.model["notification"] = value;
    console.log(this.model); 
  }

}
